import api from '@/api/disaster-names'

export default {
  state: {
    names: []
  },
  mutations: {
    setNames (state, value) {
      state.names = value
    }
  },
  actions: {
    create (store, params) {
      return api.create(params)
    },
    fetch ({commit}, params) {
      return api.get(params)
        .then((res) => {
          commit('setNames', res.data.data)
        })
    }
  },
  getters: {
    names: (state) => state.names
  },
  namespaced: true
}
